import { useState } from 'react'
import * as m from '~/paraglide/messages'
import { QuickCreateFab } from '~/widgets/quick-create-fab'
import { DashboardLeftSidebar } from './left-sidebar'
import { DashboardMobileHeader } from './mobile-header'
import { ProfileRouteGuard } from './profile-route-guard'

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="beacon-canvas min-h-dvh">
      {sidebarOpen && (
        <button
          type="button"
          className="lg:hidden z-40 fixed inset-0 bg-black/50"
          onClick={() => setSidebarOpen(false)}
          aria-label={m.closeSidebar()}
        />
      )}

      <DashboardLeftSidebar sidebarOpen={sidebarOpen} onCloseMobile={() => setSidebarOpen(false)} />

      <div className="lg:pl-64">
        <DashboardMobileHeader onOpenMobile={() => setSidebarOpen(true)} />

        <main className="beacon-enter px-4 pt-4 pb-12 sm:px-6 lg:px-10 lg:pt-12">
          <div className="mx-auto w-full max-w-[1200px]">
            <ProfileRouteGuard>{children}</ProfileRouteGuard>
          </div>
        </main>
      </div>

      <QuickCreateFab />
    </div>
  )
}
